import {
  Skeleton as ChakraSkeleton,
  SkeletonCircle as ChakraSkeletonCircle,
  SkeletonProps as ChakraSkeletonProps,
} from '@chakra-ui/react'

export type SkeletonProps = ChakraSkeletonProps & { isLoading?: boolean }

/**
 * For use inside inline-text content.
 *
 * Wrap inline elements to replace if isLoading is true
 */
export const InlineSkeleton = ({
  isLoading,
  children,
  ...props
}: SkeletonProps) => {
  if (isLoading) {
    return (
      <ChakraSkeleton
        variant="shine"
        verticalAlign="middle"
        display="inline-block"
        w="100px"
        maxW="100%"
        h="1em"
        rounded="full"
        {...props}
      />
    )
  }

  return children
}

export const Skeleton = ({ isLoading, children, ...props }: SkeletonProps) => {
  if (isLoading) {
    return <ChakraSkeleton variant="shine" rounded="full" {...props} />
  }

  return children
}

export const SkeletonCircle = ({
  isLoading,
  children,
  ...props
}: SkeletonProps) => {
  if (isLoading) {
    return <ChakraSkeletonCircle variant="shine" {...props} />
  }

  return children
}
